module.exports = __webpack_public_path__ + "static/media/bg-night3.26ce0e68.jpg";